// extracted by mini-css-extract-plugin
export default {"container":"yearDistribution_container__r9eJs","row":"yearDistribution_row__cjNA0","chart":"yearDistribution_chart__9pJrO","table":"yearDistribution_table__qA2qQ"};